/**
 * Google reCAPTCHA 相关统一配置
 * 供 webLogin（RoLogin）与 officialTopupNew（AccountLogin）共用
 * 扩展白名单游戏 / 风控错误码时，只需修改本文件
 * 当前文件目前只针对 gnjoy.hk 的游戏进行配置（因为RECAPTCHA_SITE_KEY是gnjoy.hk的）
 */

/** Google reCAPTCHA v2 site key */
export const RECAPTCHA_SITE_KEY = '6LfBcUctAAAAAFjYG4Cx20htWq_y4VSFL4HfTkiM';

/** 启用 Google 验证码的游戏 ID 白名单 */
export const OPEN_GV_GAME_IDS = [386, 456];

/** 登录接口返回以下错误码时要求人机验证 */
export const RECAPTCHA_RISK_ERROR_CODES = ['900239', '900240'];

/** 验证码展示状态 Cookie，风控触发后写入，有效期 1 小时 */
export const RECAPTCHA_COOKIE_KEY = 'recaptchaCookie';
